import { render } from "./Load.vue?vue&type=template&id=71992a0e&scoped=true&ts=true"
import script from "./Load.vue?vue&type=script&lang=ts"
export * from "./Load.vue?vue&type=script&lang=ts"

import "./Load.vue?vue&type=style&index=0&id=71992a0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71992a0e"]])

export default __exports__